import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [{
  path: '/',
  name: 'index',
  component: () => import('../views/index.vue')
},{
  path: '/map',
  name: 'map',
  component: () => import('../views/map.vue')
},{
  path: '/view2',
  name: 'view2',
  component: () => import('../view2/index.vue')
},
  {
    path: '/view3',
    name: 'view3',
    component: () => import('../view3/index.vue')
  }]
const router = new VueRouter({
  mode: "history",
  routes
})

export default router
